import styled from 'styled-components';
import { Banner } from '@trevor/ui-components';

export const BillingBanner = styled(Banner).attrs({ severity: 'info' })`
  margin-bottom: var(--spacing-l);

  a {
    font-size: inherit;
    display: unset;
    font-weight: bold;
    color: inherit;
    text-decoration: underline;
  }
`;

export const PlanContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-l);
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
